import { Handle, Position } from "reactflow"
import { getCarImagePath } from "../../../utils/getCarImagePath"

export const VehiclePictureNode = ({data}: {data: {name: string}}) => {
	return (
		<div className="vehicle-picture-node">
			<img 
				className="vehicle-picture-node-image"
				src={getCarImagePath(data.name, false)} 
				alt={data.name} 
			/>

			<Handle type="target" position={Position.Left} style={{ visibility: "hidden", transform: 'translateX(3px)' }} />
			<Handle type="source" position={Position.Right} style={{ visibility: "hidden", transform: 'translateX(-140px)' }} />
		</div>
	)
}